import _extends from 'babel-runtime/helpers/extends';
/** 工作日志路由+ */
import Layout from '@/views/layout/WorkLogLayout';

var layout = function layout(hidden) {
  var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    path: '/workLog',
    component: Layout,
    alwaysShow: false,
    hidden: hidden,
    meta: _extends({
      requiresAuth: true,
      permissions: ['oa', 'log']
    }, meta)
  };
};

export default [_extends({}, layout(true), {
  children: [{
    path: 'index/:type',
    meta: {
      redirect: 'index/all' // 获取传参的重置链接
    },
    component: function component() {
      return import('@/views/workLog/index');
    }
  }]
}), _extends({}, layout(false), {
  ignore: true, // 路由添加时忽略
  children: [{
    path: 'index/all',
    meta: {
      title: '全部',
      icon: 'all'
    }
  }]
}), _extends({}, layout(false), {
  ignore: true,
  children: [{
    path: 'index/send',
    meta: {
      title: '我发出的',
      icon: 'copy-to'
    }
  }]
}), _extends({}, layout(false), {
  ignore: true,
  children: [{
    path: 'index/received',
    meta: {
      title: '我收到的',
      icon: 'email'
    }
  }]
}), _extends({}, layout(false, {
  permissions: ['crm', 'followRecord', 'read']
}), {
  children: [{
    path: 'follow',
    component: function component() {
      return import('@/views/workLog/FollowIndex');
    },
    meta: {
      title: '跟进记录',
      icon: 'message'
    }
  }]
})];